import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SurveyField, CustomizeTemplateState } from '@/types/survey.types';

const initialState: CustomizeTemplateState = {
  surveyFields: { list: [], loading: false },
  quizInfo: { data: null, loading: false },
  saveLogic: { loading: false, error: null },
  saveQuizWeights: { loading: false, error: null },
};

const customizeTemplateSlice = createSlice({
  name: 'customizeTemplate',
  initialState,
  reducers: {
    fetchSurveyFieldsRequest(state, _action: PayloadAction<string>) {
      state.surveyFields = { list: [], loading: true };
    },
    fetchSurveyFieldsSuccess(state, action: PayloadAction<SurveyField[]>) {
      state.surveyFields = { list: action.payload, loading: false };
    },
    fetchSurveyFieldsFailure(state) {
      state.surveyFields.loading = false;
    },

    fetchQuizInfoRequest(state, _action: PayloadAction<string>) {
      state.quizInfo = { data: null, loading: true };
    },
    fetchQuizInfoSuccess(state, action: PayloadAction<Record<string, unknown>>) {
      state.quizInfo = { data: action.payload, loading: false };
    },
    fetchQuizInfoFailure(state) {
      state.quizInfo.loading = false;
    },

    saveQuizWeightsRequest(state, _action: PayloadAction<{ surveyId: string; weights: Record<string, unknown> }>) {
      state.saveQuizWeights = { loading: true, error: null };
    },
    saveQuizWeightsSuccess(state) {
      state.saveQuizWeights = { loading: false, error: null };
    },
    saveQuizWeightsFailure(state, action: PayloadAction<string>) {
      state.saveQuizWeights = { loading: false, error: action.payload };
    },

    saveSurveyLogicRequest(state, _action: PayloadAction<{ surveyId: string; logic: Record<string, unknown> }>) {
      state.saveLogic = { loading: true, error: null };
    },
    saveSurveyLogicSuccess(state) {
      state.saveLogic = { loading: false, error: null };
    },
    saveSurveyLogicFailure(state, action: PayloadAction<string>) {
      state.saveLogic = { loading: false, error: action.payload };
    },

    clearCustomizeState() {
      return initialState;
    },
  },
});

export const {
  fetchSurveyFieldsRequest, fetchSurveyFieldsSuccess, fetchSurveyFieldsFailure,
  fetchQuizInfoRequest, fetchQuizInfoSuccess, fetchQuizInfoFailure,
  saveQuizWeightsRequest, saveQuizWeightsSuccess, saveQuizWeightsFailure,
  saveSurveyLogicRequest, saveSurveyLogicSuccess, saveSurveyLogicFailure,
  clearCustomizeState,
} = customizeTemplateSlice.actions;
export default customizeTemplateSlice.reducer;
